package ru.villawonka.app.presentation.design.components

enum class AppIconButtonSize {
    STANDART,
    SMALL
}